import BaseApiService from './api.base.service'

class BackOfficeManagerService extends BaseApiService {
  constructor() {
    super('BackOfficeManager')
  }

  getBannerList() {
    return this.callGet('/Banner')
  }

  insertBanner(bannerDto) {
    return this.callPost('/Banner', bannerDto, {
      headers: { 'Content-Type': 'application/json' },
    })
  }

  editBanner(bannerId, bannerDto) {
    return this.callPatch(`/Banner/?bannerId=${bannerId}&`, bannerDto, {
      headers: { 'Content-Type': 'application/json' },
    })
  }

  deleteBanner(bannerId) {
    return this.callDelete(`/Banner/?bannerId=${bannerId}&`)
  }

  getBannerRuleList() {
    return this.callGet('/BannerManagement')
  }

  insertBannerRule(bannerGestioneDto) {
    return this.callPost('/BannerManagement', bannerGestioneDto, {
      headers: { 'Content-Type': 'application/json' },
    })
  }

  editBannerRule(bannerGestioneId, bannerGestioneDto) {
    return this.callPatch(
      `/BannerManagement/?bannerGestioneId=${bannerGestioneId}&`,
      bannerGestioneDto,
      { headers: { 'Content-Type': 'application/json' } }
    )
  }

  deleteBannerRule(bannerGestioneId) {
    return this.callDelete(
      `/BannerManagement/?bannerGestioneId=${bannerGestioneId}&`
    )
  }

  bomImportDocumentFile(type, file) {
    return this.callPost(`/import-document?importDocumentType=${type}`, file, {
      headers: { 'Content-Type': 'application/json' },
    })
  }

  bomImportDocumentSubscription(type, file) {
    return this.callPost(
      `/import-document-subscription?importDocumentType=${type}`,
      file,
      {
        headers: { 'Content-Type': 'application/json' },
      }
    )
  }

  sendMailToBomImportDocumentToCustomers(sendMailParams) {
    return this.callPost(`/send-mail-import-document`, sendMailParams, {
      headers: { 'Content-Type': 'application/json' },
    })
  }

  bomDuplicateDocument(data) {
    return this.callPost(`/duplicate-document`, data, {
      headers: { 'Content-Type': 'application/json' },
    })
  }

  getDynamicFormsList() {
    return this.callGet('/DynamicForms')
  }

  deleteBomOrder(orderId) {
    return this.callDelete(`/delete-bom-order/?orderId=${orderId}`)
  }

  chekIfAnyRowsInShopHead(orderId) {
    return this.callGet(`/any-order-rows/?orderId=${orderId}`)
  }
}

export const backOfficeManagerApi = new BackOfficeManagerService()
